<template>
  <div :class="getSiteBackground()">
    <div class="resume-screen-overlay">
      <br aria-hidden="true" />
      <br aria-hidden="true" />
      <div :class="getResumeAreaClass()">
        <br aria-hidden="true" />
        <div class="float-left">
          <button aria-label="volume" class="narration-button mr-4" v-on:click="onMainAudioClicked()"><font-awesome-icon :icon="getVolumeIcon()" /></button>
          <button aria-label="imprimer" class="narration-button" onclick="window.print()"><font-awesome-icon icon="print" /></button>
        </div>
        <br aria-hidden="true" />
        <div :class="getGreenBorderClass()">
          <br aria-hidden="true" />
          <div class="resume-page">
            <h1 class="h2">{{ LG("CR_resumeHeading") }}</h1>
            <br aria-hidden="true" />
            <p v-html="LG(getResumeParagraph())" v-if="hasResumeParagraph()"></p>
            <ul>
              <li class="mb-3" v-for="bullet in this.clueResumes[this.getCurrentSituation()].bullets" :key="bullet.text">
                <span v-if="bullet.popover == null" v-html="LG(bullet.text)"></span>
                <span v-else>
                  <PopupLinker :paragraph="LG(bullet.text)" :content="LG(bullet.popover)" :content2="LG(bullet.popover2)"></PopupLinker>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <br aria-hidden="true" />

        <div v-if="newVersion()">
          <br aria-hidden="true" />
          <br aria-hidden="true" />
          <div v-for="(recap, index) in getRecaps()" :key="recap.id">
            <h2 class="sr-only">Indice {{ index + 1 }}</h2>
            <span aria-hidden="true">{{ index + 1 }}.</span> <button v-if="hasRecapAudio(index)" aria-label="Écouter la Note pédagogique" class="narration-button" v-on:click="onAudioClicked(index)"><font-awesome-icon :icon="getPlayPauseButtonIcon(index)" /></button>
            <br aria-hidden="true" />
            <div class="row">
              <div class="col-sm-4">
                <img :src="getImage(recap.recapImage)" class="img-fluid centered-element recap-image" :alt="LG(recap.recapAlt)" />
              </div>
              <div class="col-sm">
                <h3 class="h2">{{ LG("CR_pedagogyHeading") }}</h3>
                <br aria-hidden="true" />
                <p v-html="LG(getPedagogy(index))" v-if="!hasPedagogyPopover(index)"></p>
                <p v-if="hasPedagogyPopover(index)">
                  <PopupLinker :paragraph="LG(getPedagogy(index))" :content="LG(recap.popover)"></PopupLinker>
                </p>
              </div>
            </div>
            <br aria-hidden="true" />
            <hr aria-hidden="true" />
            <div v-if="hasRecapAudio(index)">
              <AudioPlayer :id="getRecapAudioId(index)" :ref="getRecapAudioRef(index)" autoplay="no" :url="getRecapAudio(index)" @audio-ended="onRecapAudioEnded(index)"></AudioPlayer>
            </div>
          </div>
        </div>

        <div class="centered-element">
          <b-button class="funky-shape" v-on:click="onContinueButtonClicked()">{{ LG("G_continueLabel") }}</b-button>
        </div>
        <br aria-hidden="true" />
      </div>
    </div>

    <AudioPlayer id="id-clue-audio" autoplay="yes" registered="yes" :url="getClueAudio()"></AudioPlayer>
  </div>
</template>

<script>
import AudioPlayer from "../components/AudioPlayer.vue";
import PopupLinker from "../components/PopupLinker.vue";

export default {
  components: {
    AudioPlayer,
    PopupLinker,
  },
  data() {
    return {
      areaName: this.$route.params.areaName,
      situationName: this.$route.params.situationName,

      // Arrays
      clueResumes: [
        {
          id: "id-situation-1",
          paragraph: "CR_S1_Paragraph",
          bullets: [
            {
              text: "CR_S1_Bullet1",
            },
            {
              text: "CR_S1_Bullet2",
            },
            {
              text: "CR_S1_Bullet3",
            },
            {
              text: "CR_S1_Bullet4",
            },
            {
              text: "CR_S1_Bullet5",
            },
            {
              text: "CR_S1_Bullet6",
            },
          ],
          audioUrl: "/audio/scene1/L'accueil des familles_023.mp3",
          recaps: [
            {
              id: "id-calendar",
              recapImage: "scenes/scene1/MES1_Indice1_Sommaire.png",
              recapAlt: "PP_S1_O1_altRecap",
              recapPedagogy: "PP_S1_O1_recapPedagogy",
              audioNoteUrl: "/audio/scene1/L'accueil des familles_009.mp3",
              playing: false,
            },
            {
              id: "id-rug",
              recapImage: "scenes/scene1/MES1_Indice2_Sommaire.png",
              recapAlt: "PP_S1_O2_altRecap",
              recapPedagogy: "PP_S1_O2_recapPedagogy",
              audioNoteUrl: "/audio/scene1/L'accueil des familles_012.mp3",
              playing: false,
            },
            {
              id: "id-shelf",
              recapImage: "scenes/scene1/MES1_Indice3_Sommaire.png",
              recapAlt: "PP_S1_O3_altRecap",
              recapPedagogy: "PP_S1_O3_recapPedagogy",
              audioNoteUrl: "/audio/scene1/L'accueil des familles_015.mp3",
              playing: false,
            },
            {
              id: "id-mirror",
              recapImage: "scenes/scene1/MES1_Indice5_Sommaire.png",
              recapAlt: "PP_S1_O4_altRecap",
              recapPedagogy: "PP_S1_O4_recapPedagogy",
              audioNoteUrl: "/audio/scene1/L'accueil des familles_018.mp3",
              popover: "PP_S1_O4_popover",
              playing: false,
            },
            {
              id: "id-basket",
              recapImage: "scenes/scene1/MES1_Indice6_Sommaire.png",
              recapAlt: "PP_S1_O5_altRecap",
              recapPedagogy: "PP_S1_O5_recapPedagogy",
              audioNoteUrl: "/audio/scene1/L'accueil des familles_021.mp3",
              playing: false,
            },
          ],
        },
        {
          id: "id-situation-2",
          paragraph: "CR_S2_Paragraph",
          bullets: [
            {
              text: "CR_S2_Bullet1",
            },
            {
              text: "CR_S2_Bullet2",
            },
            {
              text: "CR_S2_Bullet3",
            },
            {
              text: "CR_S2_Bullet4",
            },
            {
              text: "CR_S2_Bullet5",
            },
          ],
          audioUrl: "/audio/scene2/L'écoute visible_019.mp3",
          recaps: [
            {
              id: "id-boy-drawing",
              recapImage: "scenes/scene2/MES2Indice1.png",
              recapAlt: "PP_S2_O1_altRecap",
              recapPedagogy: "PP_S2_O1_recapPedagogy",
              popover: "PP_S2_O1_recapPedagogy_popover",
              audioNoteUrl: "/audio/scene2/L'écoute visible_005.mp3",
              playing: false,
            },
            {
              id: "id-camera",
              recapImage: "scenes/scene2/MES2Indice2.png",
              recapAlt: "PP_S2_O2_altRecap",
              recapPedagogy: "PP_S2_O2_recapPedagogy",
              audioNoteUrl: "/audio/scene2/L'écoute visible_008.mp3",
              playing: false,
            },
            {
              id: "id-chariot",
              recapImage: "scenes/scene2/MES2Indice4.png",
              recapAlt: "PP_S2_O4_altRecap",
              recapPedagogy: "PP_S2_O4_recapPedagogy",
              audioNoteUrl: "/audio/scene2/L'écoute visible_011.mp3",
              playing: false,
            },
            {
              id: "id-children",
              recapImage: "scenes/scene2/MES2Indice5.png",
              recapAlt: "PP_S2_O5_altRecap",
              recapPedagogy: "PP_S2_O5_recapPedagogy",
              audioNoteUrl: "/audio/scene2/L'écoute visible_014.mp3",
              playing: false,
            },
            {
              id: "id-nest",
              recapImage: "scenes/scene2/MES2Indice6.png",
              recapAlt: "PP_S2_O6_altRecap",
              recapPedagogy: "PP_S2_O6_recapPedagogy",
              audioNoteUrl: "/audio/scene2/L'écoute visible_017.mp3",
              playing: false,
            },
          ],
        },
        {
          id: "id-situation-3",
          bullets: [
            {
              text: "CR_S3_Bullet1",
            },
            {
              text: "CR_S3_Bullet2",
            },
            {
              text: "CR_S3_Bullet3",
            },
            {
              text: "CR_S3_Bullet4",
            },
            {
              text: "CR_S3_Bullet5",
            },
          ],
          audioUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_19.mp3",
          recaps: [
            {
              id: "id-leonie",
              recapImage: "scenes/scene3/MES3Indice1.png",
              recapAlt: "PP_S3_O1_altRecap",
              recapPedagogy: "PP_S3_O1_recapPedagogy",
              audioNoteUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_05.mp3",
              playing: false,
            },
            {
              id: "id-kenji",
              recapImage: "scenes/scene3/MES3Indice2.png",
              recapAlt: "PP_S3_O2_altRecap",
              recapPedagogy: "PP_S3_O2_recapPedagogy",
              audioNoteUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_08.mp3",
              playing: false,
            },
            {
              id: "id-caroline",
              recapImage: "scenes/scene3/MES3Indice3.png",
              recapAlt: "PP_S3_O3_altRecap",
              recapPedagogy: "PP_S3_O3_recapPedagogy",
              audioNoteUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_11.mp3",
              playing: false,
            },
            {
              id: "id-zahra",
              recapImage: "scenes/scene3/MES3Indice5.png",
              recapAlt: "PP_S3_O5_altRecap",
              recapPedagogy: "PP_S3_O5_recapPedagogy",
              audioNoteUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_14.mp3",
              playing: false,
            },
            {
              id: "id-sophie",
              recapImage: "scenes/scene3/MES3Indice6.png",
              recapAlt: "PP_S3_O6_altRecap",
              recapPedagogy: "PP_S3_O6_recapPedagogy",
              audioNoteUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_17.mp3",
              playing: false,
            },
          ],
        },
        {
          id: "id-situation-4",
          bullets: [
            {
              text: "CR_S4_Bullet1",
            },
            {
              text: "CR_S4_Bullet2",
            },
            {
              text: "CR_S4_Bullet3",
            },
            {
              text: "CR_S4_Bullet4",
            },
            {
              text: "CR_S4_Bullet5",
            },
          ],
          audioUrl: "/audio/scene4/Ici, je suis chez moi_019.mp3",
          recaps: [
            {
              id: "id-baby",
              recapImage: "scenes/scene4/MES4Indice1.png",
              recapAlt: "PP_S4_O1_altRecap",
              recapPedagogy: "PP_S4_O1_recapPedagogy",
              audioNoteUrl: "/audio/scene4/Ici, je suis chez moi_005.mp3",
              playing: false,
            },
            {
              id: "id-kenji-sam",
              recapImage: "scenes/scene4/MES4Indice2.png",
              recapAlt: "PP_S4_O2_altRecap",
              recapPedagogy: "PP_S4_O2_recapPedagogy",
              audioNoteUrl: "/audio/scene4/Ici, je suis chez moi_008.mp3",
              playing: false,
            },
            {
              id: "id-zahra",
              recapImage: "scenes/scene4/MES4Indice3.png",
              recapAlt: "PP_S4_O3_altRecap",
              recapPedagogy: "PP_S4_O3_recapPedagogy",
              audioNoteUrl: "/audio/scene4/Ici, je suis chez moi_011.mp3",
              playing: false,
            },
            {
              id: "id-dara",
              recapImage: "scenes/scene4/MES4Indice4.png",
              recapAlt: "PP_S4_O4_altRecap",
              recapPedagogy: "PP_S4_O4_recapPedagogy",
              popover: "PP_S4_O4_recapPedagogy_popover",
              audioNoteUrl: "/audio/scene4/Ici, je suis chez moi_014.mp3",
              playing: false,
            },
            {
              id: "id-mom",
              recapImage: "scenes/scene4/MES4Indice5.png",
              recapAlt: "PP_S4_O5_altRecap",
              recapPedagogy: "PP_S4_O5_recapPedagogy",
              audioNoteUrl: "/audio/scene4/Ici, je suis chez moi_017.mp3",
              playing: false,
            },
          ],
        },
        {
          id: "id-situation-5",
          bullets: [
            {
              text: "CR_S5_Bullet1",
            },
            {
              text: "CR_S5_Bullet2",
            },
            {
              text: "CR_S5_Bullet3",
            },
            {
              text: "CR_S5_Bullet4",
            },
            {
              text: "CR_S5_Bullet5",
            },
          ],
          audioUrl: "/audio/scene5/Nature et découverte_019.mp3",
          recaps: [
            {
              id: "id-kenji-sam",
              recapImage: "scenes/scene5/MES5Indice1.png",
              recapAlt: "PP_S5_O1_altRecap",
              recapPedagogy: "PP_S5_O1_recapPedagogy",
              audioNoteUrl: "/audio/scene5/Nature et découverte_008.mp3",
              playing: false,
            },
            {
              id: "id-painting",
              recapImage: "scenes/scene5/MES5Indice2.png",
              recapAlt: "PP_S5_O2_altRecap",
              recapPedagogy: "PP_S5_O2_recapPedagogy",
              audioNoteUrl: "/audio/scene5/Nature et découverte_014.mp3",
              playing: false,
            },
            {
              id: "id-building",
              recapImage: "scenes/scene5/MES5Indice3.png",
              recapAlt: "PP_S5_O3_altRecap",
              recapPedagogy: "PP_S5_O3_recapPedagogy",
              audioNoteUrl: "/audio/scene5/Nature et découverte_011.mp3",
              playing: false,
            },
            {
              id: "id-door",
              recapImage: "scenes/scene5/MES5Indice5.png",
              recapAlt: "PP_S5_O5_altRecap",
              recapPedagogy: "PP_S5_O5_recapPedagogy",
              audioNoteUrl: "/audio/scene5/Nature et découverte_017.mp3",
              playing: false,
            },
            {
              id: "id-book",
              recapImage: "scenes/scene5/MES5Indice6.png",
              recapAlt: "PP_S5_O6_altRecap",
              recapPedagogy: "PP_S5_O6_recapPedagogy",
              audioNoteUrl: "/audio/scene5/Nature et découverte_005.mp3",
              playing: false,
            },
          ],
        },
        {
          id: "id-situation-6",
          bullets: [
            {
              text: "CR_S6_Bullet1",
            },
            {
              text: "CR_S6_Bullet2",
            },
            {
              text: "CR_S6_Bullet3",
            },
            {
              text: "CR_S6_Bullet4",
            },
            {
              text: "CR_S6_Bullet5",
            },
            {
              text: "CR_S6_Bullet6",
            },
          ],
          audioUrl: "/audio/scene6/Un environnement riche_019.mp3",
          recaps: [
            {
              id: "id-blocks",
              recapImage: "scenes/scene6/MES6Indice1.png",
              recapAlt: "PP_S6_O1_altRecap",
              recapPedagogy: "PP_S6_O1_recapPedagogy",
              audioNoteUrl: "/audio/scene6/Un environnement riche_008.mp3",
              playing: false,
            },
            {
              id: "id-kitchen",
              recapImage: "scenes/scene6/MES6Indice3.png",
              recapAlt: "PP_S6_O3_altRecap",
              recapPedagogy: "PP_S6_O3_recapPedagogy",
              popover: "PP_S6_O3_recapPedagogy_popover",
              audioNoteUrl: "/audio/scene6/Un environnement riche_017.mp3",
              playing: false,
            },
            {
              id: "id-books",
              recapImage: "scenes/scene6/MES6Indice4.png",
              recapAlt: "PP_S6_O4_altRecap",
              recapPedagogy: "PP_S6_O4_recapPedagogy",
              popover: "PP_S6_O4_recapPedagogy_popover",
              audioNoteUrl: "/audio/scene6/Un environnement riche_005.mp3",
              playing: false,
            },
            {
              id: "id-sand",
              recapImage: "scenes/scene6/MES6Indice5.png",
              recapAlt: "PP_S6_O5_altRecap",
              recapPedagogy: "PP_S6_O5_recapPedagogy",
              audioNoteUrl: "/audio/scene6/Un environnement riche_011.mp3",
              playing: false,
            },
            {
              id: "id-paint",
              recapImage: "scenes/scene6/MES6Indice6.png",
              recapAlt: "PP_S6_O6_altRecap",
              recapPedagogy: "PP_S6_O6_recapPedagogy",
              audioNoteUrl: "/audio/scene6/Un environnement riche_014.mp3",
              playing: false,
            },
          ],
        },
        {
          id: "id-situation-7",
          bullets: [
            {
              text: "CR_S7_Bullet1",
            },
            {
              text: "CR_S7_Bullet2",
            },
            {
              text: "CR_S7_Bullet3",
            },
            {
              text: "CR_S7_Bullet4",
            },
            {
              text: "CR_S7_Bullet5",
            },
          ],
          audioUrl: "/audio/scene7/Cultiver des saines habitudes de vie_019.mp3",
          recaps: [
            {
              id: "id-horse",
              recapImage: "scenes/scene7/MES7Indice1.png",
              recapAlt: "PP_S7_O1_altRecap",
              recapPedagogy: "PP_S7_O1_recapPedagogy",
              audioNoteUrl: "/audio/scene7/Cultiver des saines habitudes de vie_005.mp3",
              playing: false,
            },
            {
              id: "id-mug",
              recapImage: "scenes/scene7/MES7Indice2.png",
              recapAlt: "PP_S7_O2_altRecap",
              recapPedagogy: "PP_S7_O2_recapPedagogy",
              popover: "PP_S7_O2_recapPedagogy_popover",
              audioNoteUrl: "/audio/scene7/Cultiver des saines habitudes de vie_008.mp3",
              playing: false,
            },
            {
              id: "id-salad",
              recapImage: "scenes/scene7/MES7Indice3.png",
              recapAlt: "PP_S7_O3_altRecap",
              recapPedagogy: "PP_S7_O3_recapPedagogy",
              // popover: "PP_S7_O3_recapPedagogy_popover",
              audioNoteUrl: "/audio/scene7/Cultiver des saines habitudes de vie_014.mp3",
              playing: false,
            },
            {
              id: "id-tray",
              recapImage: "scenes/scene7/MES7Indice5.png",
              recapAlt: "PP_S7_O5_altRecap",
              recapPedagogy: "PP_S7_O5_recapPedagogy",
              audioNoteUrl: "/audio/scene7/Cultiver des saines habitudes de vie_017.mp3",
              playing: false,
            },
            {
              id: "id-chair",
              recapImage: "scenes/scene7/MES7Indice6.png",
              recapAlt: "PP_S7_O6_altRecap",
              recapPedagogy: "PP_S7_O6_recapPedagogy",
              audioNoteUrl: "/audio/scene7/Cultiver des saines habitudes de vie_011.mp3",
              playing: false,
            },
          ],
        },
        {
          id: "id-situation-8",
          bullets: [
            {
              text: "CR_S8_Bullet1",
            },
            {
              text: "CR_S8_Bullet2",
            },
            {
              text: "CR_S8_Bullet3",
            },
            {
              text: "CR_S8_Bullet4",
            },
            {
              text: "CR_S8_Bullet5",
            },
          ],
          audioUrl: "/audio/scene8/On joue dehors_019.mp3",
          recaps: [
            {
              id: "id-garden",
              recapImage: "scenes/scene8/MES8Indice1.png",
              recapAlt: "PP_S8_O1_altRecap",
              recapPedagogy: "PP_S8_O1_recapPedagogy",
              audioNoteUrl: "/audio/scene8/On joue dehors_014.mp3",
              playing: false,
            },
            {
              id: "id-stroller",
              recapImage: "scenes/scene8/MES8Indice2.png",
              recapAlt: "PP_S8_O2_altRecap",
              recapPedagogy: "PP_S8_O2_recapPedagogy",
              popover: "PP_S8_O2_recapPedagogy_popover",
              audioNoteUrl: "/audio/scene8/On joue dehors_011.mp3",
              playing: false,
            },
            {
              id: "id-cubes",
              recapImage: "scenes/scene8/MES8Indice3.png",
              recapAlt: "PP_S8_O3_altRecap",
              recapPedagogy: "PP_S8_O3_recapPedagogy",
              popover: "PP_S8_O3_recapPedagogy_popover",
              audioNoteUrl: "/audio/scene8/On joue dehors_008.mp3",
              playing: false,
            },
            {
              id: "id-picnic",
              recapImage: "scenes/scene8/MES8Indice4.png",
              recapAlt: "PP_S8_O4_altRecap",
              recapPedagogy: "PP_S8_O4_recapPedagogy",
              popover: "PP_S8_O4_recapPedagogy_popover",
              audioNoteUrl: "/audio/scene8/On joue dehors_017.mp3",
              playing: false,
            },
            {
              id: "id-counter",
              recapImage: "scenes/scene8/MES8Indice6.png",
              recapAlt: "PP_S8_O6_altRecap",
              recapPedagogy: "PP_S8_O6_recapPedagogy",
              popover: "PP_S8_O6_recapPedagogy_popover",
              audioNoteUrl: "/audio/scene8/On joue dehors_005.mp3",
              playing: false,
            },
          ],
        },
        {
          id: "id-situation-9",
          bullets: [
            {
              text: "CR_S9_Bullet1",
            },
            {
              text: "CR_S9_Bullet2",
            },
            {
              text: "CR_S9_Bullet3",
            },
            {
              text: "CR_S9_Bullet4",
            },
            {
              text: "CR_S9_Bullet5",
            },
          ],
          audioUrl: "/audio/scene9/MES1-4.mp3",
          recaps: [
            {
              id: "id-1",
              recapImage: "scenes/scene9/MES9Indice1.png",
              recapAlt: "PP_S9_O1_altRecap",
              recapPedagogy: "PP_S9_O1_recapPedagogy",
              audioNoteUrl: "/audio/scene9/MES1-3-1NP.mp3",
              playing: false,
            },
            {
              id: "id-2",
              recapImage: "scenes/scene9/MES9Indice2.png",
              recapAlt: "PP_S9_O2_altRecap",
              recapPedagogy: "PP_S9_O2_recapPedagogy",
              audioNoteUrl: "/audio/scene9/MES1-3-2NP.mp3",
              playing: false,
            },
            {
              id: "id-3",
              recapImage: "scenes/scene9/MES9Indice3.png",
              recapAlt: "PP_S9_O3_altRecap",
              recapPedagogy: "PP_S9_O3_recapPedagogy",
              audioNoteUrl: "/audio/scene9/MES1-3-3NP.mp3",
              playing: false,
            },
            {
              id: "id-4",
              recapImage: "scenes/scene9/MES9Indice4.png",
              recapAlt: "PP_S9_O4_altRecap",
              recapPedagogy: "PP_S9_O4_recapPedagogy",
              audioNoteUrl: "/audio/scene9/MES1-3-4NP.mp3",
              playing: false,
            },
            {
              id: "id-5",
              recapImage: "scenes/scene9/MES9Indice5.png",
              recapAlt: "PP_S9_O5_altRecap",
              recapPedagogy: "PP_S9_O5_recapPedagogy",
              audioNoteUrl: "/audio/scene9/MES1-3-5NP.mp3",
              playing: false,
            },
          ],
        },
        {
          id: "id-situation-10",
          bullets: [
            {
              text: "CR_S10_Bullet1",
            },
            {
              text: "CR_S10_Bullet2",
            },
            {
              text: "CR_S10_Bullet3",
            },
            {
              text: "CR_S10_Bullet4",
            },
            {
              text: "CR_S10_Bullet5",
            },
          ],
          audioUrl: "/audio/scene10/MES2-4.mp3",
          recaps: [
            {
              id: "id-1",
              recapImage: "scenes/scene10/MES10Indice1.png",
              recapAlt: "PP_S10_O1_altRecap",
              recapPedagogy: "PP_S10_O1_recapPedagogy",
              audioNoteUrl: "/audio/scene10/MES2-3-1NP.mp3",
              playing: false,
            },
            {
              id: "id-2",
              recapImage: "scenes/scene10/MES10Indice2.png",
              recapAlt: "PP_S10_O2_altRecap",
              recapPedagogy: "PP_S10_O2_recapPedagogy",
              audioNoteUrl: "/audio/scene10/MES2-3-2NP.mp3",
              playing: false,
            },
            {
              id: "id-3",
              recapImage: "scenes/scene10/MES10Indice3.png",
              recapAlt: "PP_S10_O3_altRecap",
              recapPedagogy: "PP_S10_O3_recapPedagogy",
              audioNoteUrl: "/audio/scene10/MES2-3-3NP.mp3",
              playing: false,
            },
            {
              id: "id-5",
              recapImage: "scenes/scene10/MES10Indice5.png",
              recapAlt: "PP_S10_O5_altRecap",
              recapPedagogy: "PP_S10_O5_recapPedagogy",
              audioNoteUrl: "/audio/scene10/MES2-3-5NP.mp3",
              playing: false,
            },
            {
              id: "id-6",
              recapImage: "scenes/scene10/MES10Indice6.png",
              recapAlt: "PP_S10_O6_altRecap",
              recapPedagogy: "PP_S10_O6_recapPedagogy",
              audioNoteUrl: "/audio/scene10/MES2-3-6NP.mp3",
              playing: false,
            },
          ],
        },
        {
          id: "id-situation-11",
          bullets: [
            {
              text: "CR_S11_Bullet1",
            },
            {
              text: "CR_S11_Bullet2",
            },
            {
              text: "CR_S11_Bullet3",
            },
            {
              text: "CR_S11_Bullet4",
            },
            {
              text: "CR_S11_Bullet5",
            },
          ],
          audioUrl: "/audio/scene11/MES3-4.mp3",
          recaps: [
            {
              id: "id-1",
              recapImage: "scenes/scene11/MES11Indice1.png",
              recapAlt: "PP_S11_O1_altRecap",
              recapPedagogy: "PP_S11_O1_recapPedagogy",
              audioNoteUrl: "/audio/scene11/MES3-3-1NP.mp3",
              playing: false,
            },
            {
              id: "id-2",
              recapImage: "scenes/scene11/MES11Indice2.png",
              recapAlt: "PP_S11_O2_altRecap",
              recapPedagogy: "PP_S11_O2_recapPedagogy",
              popover: "PP_S11_O2_recapPedagogy_popover",
              audioNoteUrl: "/audio/scene11/MES3-3-2NP.mp3",
              playing: false,
            },
            {
              id: "id-4",
              recapImage: "scenes/scene11/MES11Indice4.png",
              recapAlt: "PP_S11_O4_altRecap",
              recapPedagogy: "PP_S11_O4_recapPedagogy",
              audioNoteUrl: "/audio/scene11/MES3-3-4NP.mp3",
              playing: false,
            },
            {
              id: "id-5",
              recapImage: "scenes/scene11/MES11Indice5.png",
              recapAlt: "PP_S11_O5_altRecap",
              recapPedagogy: "PP_S11_O5_recapPedagogy",
              audioNoteUrl: "/audio/scene11/MES3-3-5NP.mp3",
              playing: false,
            },
            {
              id: "id-6",
              recapImage: "scenes/scene11/MES11Indice6.png",
              recapAlt: "PP_S11_O6_altRecap",
              recapPedagogy: "PP_S11_O6_recapPedagogy",
              audioNoteUrl: "/audio/scene11/MES3-3-6NP.mp3",
              playing: false,
            },
          ],
        },
        {
          id: "id-situation-12",
          bullets: [
            {
              text: "CR_S12_Bullet1",
            },
            {
              text: "CR_S12_Bullet2",
              popover: "CR_S12_Bullet2_popover",
              popover2: "CR_S12_Bullet2_popover2",
            },
            {
              text: "CR_S12_Bullet3",
            },
            {
              text: "CR_S12_Bullet4",
            },
            {
              text: "CR_S12_Bullet5",
            },
          ],
          audioUrl: "/audio/scene12/MES4-4.mp3",
          recaps: [
            {
              id: "id-1",
              recapImage: "scenes/scene12/MES12Indice1.png",
              recapAlt: "PP_S12_O1_altRecap",
              recapPedagogy: "PP_S12_O1_recapPedagogy",
              audioNoteUrl: "/audio/scene12/MES4-3-1NP.mp3",
              playing: false,
            },
            {
              id: "id-2",
              recapImage: "scenes/scene12/MES12Indice2.png",
              recapAlt: "PP_S12_O2_altRecap",
              recapPedagogy: "PP_S12_O2_recapPedagogy",
              audioNoteUrl: "/audio/scene12/MES4-3-2NP.mp3",
              playing: false,
            },
            {
              id: "id-3",
              recapImage: "scenes/scene12/MES12Indice3.png",
              recapAlt: "PP_S12_O3_altRecap",
              recapPedagogy: "PP_S12_O3_recapPedagogy",
              audioNoteUrl: "/audio/scene12/MES4-3-3NP.mp3",
              playing: false,
            },
            {
              id: "id-5",
              recapImage: "scenes/scene12/MES12Indice5.png",
              recapAlt: "PP_S12_O5_altRecap",
              recapPedagogy: "PP_S12_O5_recapPedagogy",
              audioNoteUrl: "/audio/scene12/MES4-3-5NP.mp3",
              playing: false,
            },
            {
              id: "id-6",
              recapImage: "scenes/scene12/MES12Indice6.png",
              recapAlt: "PP_S12_O6_altRecap",
              recapPedagogy: "PP_S12_O6_recapPedagogy",
              audioNoteUrl: "/audio/scene12/MES4-3-6NP.mp3",
              playing: false,
            },
          ],
        },
      ],

      // Images

      // Variables
    };
  },
  computed: {},
  created() {
    this.setArea(this.areaName);
    this.setSituation(this.situationName);
  },
  methods: {
    hasRecapAudio(index) {
      if (this.getRecapAudio(index) == null) {
        return false;
      }
      return true;
    },
    getRecapAudioId(index) {
      return "recap-audio-id" + index;
    },
    getRecapAudioRef(index) {
      return "recap-audio-ref" + index;
    },
    getVolumeIcon() {
      if (this.$store.state.gamestate.muted) {
        return "volume-mute";
      } else {
        return "volume-up";
      }
    },
    getPlayPauseButtonIcon(index) {
      if (this.getRecaps()[index].playing == true) {
        return "stop";
      } else {
        return "play";
      }
    },
    onMainAudioClicked() {
      //this.playRegisteredAudio();
      if (!this.$store.state.gamestate.muted) {
        this.muteAllAudio();
        this.$store.commit("setMuted", true);
      } else {
        //this.unmuteAllAudio();
        this.playRegisteredAudio();
        this.$store.commit("setMuted", false);
      }
    },
    onRecapAudioEnded(index) {
      if (this.getRecaps()[index].playing != null) {
        this.getRecaps()[index].playing = false;
      }
    },
    onAudioClicked(index) {
      // Unmute all audio, since we're actively trying to play one
      if (!this.getRecaps()[index].playing) {
        this.$store.commit("setMuted", false);
        this.pauseAllAudio();
        this.playAudioByRefName(this.getRecapAudioRef(index));
        for (var i = 0; i < this.getRecaps().length; i++) {
          if (this.getRecaps()[i].playing != null) {
            this.getRecaps()[i].playing = false;
          }
        }
        this.getRecaps()[index].playing = true;
      } else {
        this.pauseAllAudio();
        for (var j = 0; j < this.getRecaps().length; j++) {
          if (this.getRecaps()[j].playing != null) {
            this.getRecaps()[j].playing = false;
          }
        }
      }
    },
    getRecapAudio(index) {
      return this.getRecaps()[index].audioNoteUrl;
    },
    getSiteBackground() {
      if (this.newVersion()) {
        return "site-background extend-background-new";
      } else {
        return "site-background extend-background";
      }
    },
    getImage(image) {
      return require("../assets/" + image);
    },
    getRecaps() {
      return this.clueResumes[this.getCurrentSituation()].recaps;
    },
    hasPedagogyPopover(index) {
      if (this.getRecaps()[index].popover != null) {
        return true;
      }
      return false;
    },
    getPedagogy(index) {
      return this.getRecaps()[index].recapPedagogy;
    },
    getGreenBorderClass() {
      if (this.newVersion()) {
        return "";
      }
      return "green-border";
    },
    getResumeAreaClass() {
      if (this.newVersion()) {
        return "bg-resume-area bg-popup-area-new";
      } else {
        return "bg-resume-area";
      }
    },
    getCurrentSituation() {
      return this.$store.state.gamestate.situation;
    },
    getResumeParagraph() {
      return this.clueResumes[this.getCurrentSituation()].paragraph;
    },
    hasResumeParagraph() {
      if (this.clueResumes[this.getCurrentSituation()].paragraph == null) {
        return false;
      }
      return true;
    },
    hasClueAudio() {
      if (this.getClueAudio() == null) {
        return false;
      }
      return true;
    },
    getClueAudio() {
      //console.log("FOUND: " + this.clueResumes[this.getCurrentSituation()].audioUrl);
      return this.clueResumes[this.getCurrentSituation()].audioUrl;
    },
    onContinueButtonClicked() {
      this.$router.push(`/${this.areaName}/${this.situationName}/intervention`);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.h2 {
  font-size: 18px !important;
  font-weight: 600;
}
</style>
<style>
@import url("https://fonts.googleapis.com/css?family=Poppins");
@import url("https://fonts.googleapis.com/css?family=Nunito");

.green-border {
  border: 20px solid #3f5d12;
  width: 95%;
  padding: 10px;
  border-radius: 15px 15px 15px 15px;
}

.bg-resume-area {
  position: relative;
  background-color: white;
  color: black;
  font-family: "Poppins";
  font-size: 17px;
  max-width: 1000px;
  /*min-height: 550px;*/
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  padding-left: 80px;
  padding-right: 25px;
  padding-top: 5px;
  padding-bottom: 25px;
}

.resume-screen-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: white;
  backdrop-filter: blur(6px);
}

.resume-page {
  padding: 20px;
}

.extend-background {
  min-height: 1000px !important;
}

.extend-background-new {
  min-height: 2900px !important;
}

.narration-button {
  border-radius: 5px;
  margin-left: 10px;
  /*        background-color: #7DA8BA;
        color: white;*/
}

.narration-button:hover,
.narration-button:focus {
  background-color: aquamarine;
}
</style>
